import React from "react";

import emoji1f9f6 from "../assets/emoji/1f9f6.svg";
import emoji1f4be from "../assets/emoji/1f4be.svg";
import emoji2728 from "../assets/emoji/2728.svg";
import emoji1f7e1 from "../assets/emoji/1f7e1.svg";
import emoji1f6e0 from "../assets/emoji/1f6e0.svg";
import emoji1f9f5 from "../assets/emoji/1f9f5.svg";
import emoji21a9 from "../assets/emoji/21a9.svg";
import emoji21aa from "../assets/emoji/21aa.svg";
import emoji1f58a from "../assets/emoji/1f58a.svg";
import emoji1f9fc from "../assets/emoji/1f9fc.svg";
import emoji1f4cf from "../assets/emoji/1f4cf.svg";
import emoji1faa3 from "../assets/emoji/1faa3.svg";
import emoji2702 from "../assets/emoji/2702.svg";
import emoji1f9ec from "../assets/emoji/1f9ec.svg";
import emoji2194 from "../assets/emoji/2194.svg";
import emoji2195 from "../assets/emoji/2195.svg";
import emoji2705 from "../assets/emoji/2705.svg";
import emoji1f9f9 from "../assets/emoji/1f9f9.svg";
import emoji1f50d from "../assets/emoji/1f50d.svg";
import emoji270b from "../assets/emoji/270b.svg";
import emoji1f520 from "../assets/emoji/1f520.svg";
import emoji1f521 from "../assets/emoji/1f521.svg";
import emoji1f3af from "../assets/emoji/1f3af.svg";
import emoji1f319 from "../assets/emoji/1f319.svg";
import emoji2600 from "../assets/emoji/2600.svg";
import emoji1f3a8 from "../assets/emoji/1f3a8.svg";
import emoji1f5c2 from "../assets/emoji/1f5c2.svg";
import emoji1f9f0 from "../assets/emoji/1f9f0.svg";
import emoji1f680 from "../assets/emoji/1f680.svg";

const makeEmoji = (...codes) => String.fromCodePoint(...codes);

export const EMOJI = {
  MENU: makeEmoji(0x1f9f6),
  SAVE: makeEmoji(0x1f4be),
  SPARKLE: makeEmoji(0x2728),
  PENDING: makeEmoji(0x1f7e1),
  SETTINGS: makeEmoji(0x1f6e0, 0xfe0f),
  BRANDING: makeEmoji(0x1f9f5),
  UNDO: makeEmoji(0x21a9, 0xfe0f),
  REDO: makeEmoji(0x21aa, 0xfe0f),
  DRAW: makeEmoji(0x1f58a, 0xfe0f),
  ERASE: makeEmoji(0x1f9fc),
  LINE: makeEmoji(0x1f4cf),
  FILL: makeEmoji(0x1faa3),
  SELECT: makeEmoji(0x2702, 0xfe0f),
  FIND: makeEmoji(0x1f50d),
  DUPLICATE: makeEmoji(0x1f9ec),
  FLIP_H: makeEmoji(0x2194, 0xfe0f),
  FLIP_V: makeEmoji(0x2195, 0xfe0f),
  PLACE: makeEmoji(0x2705),
  CLEAR: makeEmoji(0x1f9f9),
  PAN: makeEmoji(0x270b),
  SYMBOLS_ON: makeEmoji(0x1f520),
  SYMBOLS_OFF: makeEmoji(0x1f521),
  CENTER: makeEmoji(0x1f3af),
  ZOOM: makeEmoji(0x1f50d),
  MOON: makeEmoji(0x1f319),
  SUN: makeEmoji(0x2600, 0xfe0f),
  PALETTE: makeEmoji(0x1f3a8),
  LAYERS: makeEmoji(0x1f5c2),
  TOOLBOX: makeEmoji(0x1f9f0),
  ROCKET: makeEmoji(0x1f680),
};

const emojiAssetMap = {
  [EMOJI.MENU]: emoji1f9f6,
  [EMOJI.SAVE]: emoji1f4be,
  [EMOJI.SPARKLE]: emoji2728,
  [EMOJI.PENDING]: emoji1f7e1,
  [EMOJI.SETTINGS]: emoji1f6e0,
  [EMOJI.BRANDING]: emoji1f9f5,
  [EMOJI.UNDO]: emoji21a9,
  [EMOJI.REDO]: emoji21aa,
  [EMOJI.DRAW]: emoji1f58a,
  [EMOJI.ERASE]: emoji1f9fc,
  [EMOJI.LINE]: emoji1f4cf,
  [EMOJI.FILL]: emoji1faa3,
  [EMOJI.SELECT]: emoji2702,
  [EMOJI.DUPLICATE]: emoji1f9ec,
  [EMOJI.FLIP_H]: emoji2194,
  [EMOJI.FLIP_V]: emoji2195,
  [EMOJI.PLACE]: emoji2705,
  [EMOJI.CLEAR]: emoji1f9f9,
  [EMOJI.FIND]: emoji1f50d,
  [EMOJI.PAN]: emoji270b,
  [EMOJI.SYMBOLS_ON]: emoji1f520,
  [EMOJI.SYMBOLS_OFF]: emoji1f521,
  [EMOJI.CENTER]: emoji1f3af,
  [EMOJI.MOON]: emoji1f319,
  [EMOJI.SUN]: emoji2600,
  [EMOJI.PALETTE]: emoji1f3a8,
  [EMOJI.LAYERS]: emoji1f5c2,
  [EMOJI.TOOLBOX]: emoji1f9f0,
  [EMOJI.ROCKET]: emoji1f680,
};

export const EmojiIcon = ({ symbol, label, className, size = 18 }) => {
  const normalized =
    symbol && typeof symbol === "string"
      ? symbol.replace(/\uFE0F/g, "")
      : symbol;
  const src = emojiAssetMap[symbol] || emojiAssetMap[normalized];

  if (!src) {
    return (
      <span
        className={`emoji-fallback ${className || ""}`}
        role="img"
        aria-label={label || symbol}
      >
        {symbol}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={label || symbol}
      className={`emoji-icon ${className || ""}`}
      draggable="false"
      width={size}
      height={size}
    />
  );
};

export default EmojiIcon;
